import * as Types from '../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAutoApplyDraftListQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAutoApplyDraftListQuery = {
    __typename?: 'Query';
    findReviewBeforeSubmitDrafts?:
        | {
              __typename?: 'FindReviewBeforeSubmitDraftsPayload';
              drafts: Array<{
                  __typename?: 'AutoApplyDraft';
                  applicationDraftId: string;
                  unfilledScreenerQuestionCount?: number | null | undefined;
              }>;
          }
        | null
        | undefined;
};

export const GetAutoApplyDraftListDocument = gql`
    query GetAutoApplyDraftList {
        findReviewBeforeSubmitDrafts {
            drafts {
                applicationDraftId
                unfilledScreenerQuestionCount
            }
        }
    }
`;

/**
 * __useGetAutoApplyDraftListQuery__
 *
 * To run a query within a React component, call `useGetAutoApplyDraftListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoApplyDraftListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoApplyDraftListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoApplyDraftListQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAutoApplyDraftListQuery,
        GetAutoApplyDraftListQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAutoApplyDraftListQuery, GetAutoApplyDraftListQueryVariables>(
        GetAutoApplyDraftListDocument,
        options,
    );
}
export function useGetAutoApplyDraftListLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAutoApplyDraftListQuery,
        GetAutoApplyDraftListQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAutoApplyDraftListQuery, GetAutoApplyDraftListQueryVariables>(
        GetAutoApplyDraftListDocument,
        options,
    );
}
export function useGetAutoApplyDraftListSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAutoApplyDraftListQuery,
              GetAutoApplyDraftListQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetAutoApplyDraftListQuery, GetAutoApplyDraftListQueryVariables>(
        GetAutoApplyDraftListDocument,
        options,
    );
}
export type GetAutoApplyDraftListQueryHookResult = ReturnType<typeof useGetAutoApplyDraftListQuery>;
export type GetAutoApplyDraftListLazyQueryHookResult = ReturnType<
    typeof useGetAutoApplyDraftListLazyQuery
>;
export type GetAutoApplyDraftListSuspenseQueryHookResult = ReturnType<
    typeof useGetAutoApplyDraftListSuspenseQuery
>;
export type GetAutoApplyDraftListQueryResult = Apollo.QueryResult<
    GetAutoApplyDraftListQuery,
    GetAutoApplyDraftListQueryVariables
>;
